import { Invitee } from "../models/Invitee";
import { InviteeType } from "../models/InviteeType";
import { Member } from "../../members/models/Member";
import { Group } from "../../members/models/Group";

const formatDateFallback = (dateStart: string, timeLocal: string, timeZone: string): string => {
  if (!dateStart) return "Session";
  const date = new Date(dateStart);
  if (isNaN(date.getTime())) return "Session";

  const datePart = new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: timeZone || undefined,
  }).format(date);

  const timePart = timeLocal && /^\d{1,2}:\d{2}/.test(timeLocal)
    ? ` at ${timeLocal.slice(0, 5)}`
    : "";

  return `Session on ${datePart}${timePart}`;
};

export const generateTitleFromInvitees = (
  invitees: Invitee[],
  members: Member[],
  groups: Group[],
): string => {
  const memberMap = new Map(members.map((m) => [m.id, m]));
  const groupMap = new Map(groups.map((g) => [g.id, g]));
  const names = invitees
    .map((inv) => {
      if (inv.type === InviteeType.Group) {
        return groupMap.get(inv.invitedUserId)?.name || "";
      }
      const m = memberMap.get(inv.invitedUserId);
      return m ? `${m.firstName} ${m.lastName}`.trim() : "";
    })
    .filter(Boolean);
  return names.join(", ");
};

export const deriveSessionTitle = (
  invitees: Invitee[],
  members: Member[],
  groups: Group[],
  dateStart: string,
  timeLocal: string,
  timeZone: string,
): string => {
  const fromInvitees = generateTitleFromInvitees(invitees, members, groups);
  if (fromInvitees) return fromInvitees;
  return formatDateFallback(dateStart, timeLocal, timeZone);
};
